import script from "./CityView.vue?vue&type=script&setup=true&lang=js"
export * from "./CityView.vue?vue&type=script&setup=true&lang=js"

import "./CityView.vue?vue&type=style&index=0&id=b6c368d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6c368d6"]])

export default __exports__